
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const AuthorCTA = () => {
  return (
    <section className="py-12 md:py-16 bg-chapterly-soft-purple">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="mb-6 md:mb-0 md:mr-8 md:w-3/5">
            <h2 className="text-2xl md:text-3xl font-bold mb-3 md:mb-4">Ready to start your writing journey?</h2>
            <p className="text-base md:text-lg mb-5 md:mb-6">
              Share your stories episode by episode, build a following, 
              and earn from your creativity.
            </p>
            <Button 
              size="lg" 
              className="bg-chapterly-purple text-white hover:bg-chapterly-purple/90 w-full sm:w-auto"
              asChild
            >
              <Link to="/write">Start Writing Today</Link>
            </Button>
          </div>
          <div className="w-full md:w-2/5">
            <img
              src="https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=600&q=70&fm=webp"
              srcSet={[
                'https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=320&q=70&fm=webp 320w',
                'https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=600&q=70&fm=webp 600w',
              ].join(', ')}
              sizes="(max-width: 768px) 90vw, 40vw"
              alt="Author writing"
              className="rounded-lg shadow-lg"
              loading="lazy"
              decoding="async"
              width="600"
              height="450"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
